import { getGroupInfo, getPackInfo } from "@/common/services/search";

export default {
	levelTitle(level) {
		return this.$t("WordscapesGroupPageTableText", {
			PackName: level.name,
			LevelNumber: level.level,
		});
	},
	packTitle(pack) {
		return this.$t("WordscapesGroupPageTableHeadingLvl", {
			PackName: pack.name,
			FirstLevel: pack.min,
			LastLevel: pack.max,
		});
	},
	subItems(item) {
		return this.isMasterGroup ? item : this.packInfo(item.name).levels;
	},
	itemColor(item) {
		return this.isMasterGroup ? item[0].color : item.color;
	},
	subItemLink(item, subItem) {
		const levelLink = {
			name: "LevelPage",
			params: {
				group: this.groupInfo.name,
				pack: item.name,
				level: subItem.level,
			},
		};
		const packLink = {
			name: "PackPage",
			params: {
				group: this.groupInfo.name,
				pack: subItem.name,
			},
		};

		return this.isMasterGroup ? packLink : levelLink;
	},
	subItemTitle(subItem) {
		return this.isMasterGroup
			? this.packTitle(subItem)
			: this.levelTitle(subItem);
	},
	packInfo(pack) {
		return getPackInfo(this.$route.params.group, pack);
	},
	getLevelAd(packIndex, levelIndex) {
		// No ads available to show.
		if (!this.ads.length) return null;

		// We've already shown all ads for this page.
		if (packIndex >= this.ads.length) return null;

		if (levelIndex + 1 === this.levelsPerAd) return this.ads[packIndex];

		return null;
	},
	handleClick(level) {
		this.$store.dispatch("trackEvent", {
			eventCategory: "Group Table",
			eventAction: `Click on Group table row ${this.levelTitle(level)}`,
		});
	},
	onHeadingClick(pack) {
		this.$store.dispatch("trackEvent", {
			eventCategory: "Group Table",
			eventAction: `Click on Group table heading ${this.$t(
				"WordscapesGroupPageTableHeading",
				{
					PackName: pack.name,
					FirstLevel: pack.min,
					LastLevel: pack.max,
				}
			)}`,
		});
	},
	async refreshPage() {
		this.isError = false;
		this.isLoading = true;
		const groupInfo = await getGroupInfo(this.$route.params.group);
		this.isLoading = false;

		if (
			!(
				typeof groupInfo === "object" &&
				typeof groupInfo.name === "string"
			)
		) {
			this.isError = true;
			if (typeof window.__PRERENDER_INJECTED !== "undefined") {
				this.$nextTick(() => {
					window.document.dispatchEvent(
						new CustomEvent("spa-render-complete")
					);
				});
			}

			return;
		}

		if (groupInfo) this.groupInfo = groupInfo;

		if (this.isMasterGroup) {
			const packsList = Object.values(this.groupInfo.packs);
			const size = 16;
			for (let i = 0; i < packsList.length; i += size) {
				this.packs.push(packsList.slice(i, i + size));
			}
		}
	},
};
